import { Application } from '@hotwired/stimulus';

// v2
import { shouldLoad as shouldTableActionOverlayLoad } from "./v2/standard/standard-meinklett-table/standard-meinklett-table__action-overlay--loader";
import { shouldLoad as shouldTableFilterLoad } from "./v2/standard/standard-meinklett-table/standard-meinklett-table__filter--loader";
import { shouldLoad as shouldTableMultiSelectActionLoad } from "./v2/standard/standard-meinklett-table/standard-meinklett-table__multi-select-action--loader";
import { shouldLoad as shouldTableOverflowLoad } from "./v2/standard/standard-meinklett-table/standard-meinklett-table__overflow--loader";

export default async function init(application: Application) {
    if (shouldTableActionOverlayLoad()) {
        const { TableActionOverlayController } = await import('./v2/standard/standard-meinklett-table/standard-meinklett-table__action-overlay.stimulus');
        TableActionOverlayController.register(application);
    }

    if (shouldTableFilterLoad()) {
        const { TableFilterController } = await import('./v2/standard/standard-meinklett-table/standard-meinklett-table__filter.stimulus');
        TableFilterController.register(application);
    }

    if (shouldTableMultiSelectActionLoad()) {
        const { TableMultiSelectActionController } = await import('./v2/standard/standard-meinklett-table/standard-meinklett-table__multi-select-action.stimulus');
        TableMultiSelectActionController.register(application);
    }

    if (shouldTableOverflowLoad()) {
        const { TableOverflowController } = await import('./v2/standard/standard-meinklett-table/standard-meinklett-table__overflow.stimulus');
        TableOverflowController.register(application);
    }
}